import { Dialog } from "@headlessui/react";
import React, { useState } from "react";
import { CrossIcon } from "src/components/icons";

interface Props {
    sources: any
}

const UsedSourcesAccordion: React.FC<Props> = ({ sources }) => {
    const [open, setOpen] = useState(false);

    return (
        <div className="border rounded-lg shadow-md bg-white mb-4">
            {/* Accordion Header */}
            <button
                onClick={() => setOpen(!open)}
                className="w-full text-left px-4 py-2 flex items-center justify-between font-semibold text-gray-800 bg-gray-100 hover:bg-gray-200 transition"
            >
                <span>✅ Used Sources ({sources.length})</span>
                <span className="text-xl">{open ? "▲" : "▼"}</span>
            </button>

            {/* Accordion Body */}
            {open && (
                <Dialog
                    open={open}
                    onClose={() => {
                        undefined;
                    }}
                    className="relative z-50"
                >
                    <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

                    <div className="fixed inset-0 flex items-center justify-center p-1">
                        <Dialog.Panel className="relative bg-white w-full max-w-4xl lg:w-[70vw] p-4  rounded-xl shadow-[7px_9px_14px_0] shadow-[#000]/[0.25] max-h-[70vh] overflow-y-auto">
                            <div className="flex items-center justify-between w-full mb-4">
                                <h3 className="text-xl font-semibold text-gray-800">Used Sources</h3>
                                <CrossIcon onClick={() => setOpen(false)} className="cursor-pointer" />
                            </div>
                            <div className=" space-y-4 bg-white">
                                <table className="min-w-full border text-xs sm:text-sm">
                                    <thead className="bg-gray-100 text-left">
                                        <tr>
                                            <th className="p-1 border">Sno</th>
                                            <th className="p-1 border">Url</th>
                                            <th className="p-1 border">Query</th>
                                            <th className="p-1 border">Reason</th>
                                            <th className="p-1 border">Score</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sources.map((item: any, index: number) => (
                                            <tr key={item.url || index} className="border-t">
                                                <td className="p-1 border">{index + 1}</td>
                                                <td className="p-1 border">
                                                    <div>
                                                        <a
                                                            href={item.url}
                                                            className="text-blue-700 underline break-all mb-2"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {item.url}
                                                        </a>
                                                    </div>

                                                </td>

                                                <td className="p-1 border">{`${(item.query)}`}</td>
                                                <td className="p-1 border capitalize">{item.reason ?? "N/A"}</td>
                                                <td className="p-1 border capitalize">{item.score ?? "N/A"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </Dialog.Panel>
                    </div>
                </Dialog>
            )}
        </div>
    );
};

export default UsedSourcesAccordion;
